import { render, staticRenderFns } from "./ListGroupComponent.vue?vue&type=template&id=37e5d142&"
import script from "./ListGroupComponent.vue?vue&type=script&lang=js&"
export * from "./ListGroupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports